import { getDataFromSSR } from "@/handlers/client/commonClient";
import { logger } from "@/utils/logging/log-util";
import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
import SVG from "react-inlinesvg";
import { parseMatchDetails } from "@/utils/ipl";
import AsiaCupFAQSchema from "@/component/SeoTags/AsiaCupFaq";

const IPLCommonFooter = dynamic(() =>
  import("@/component/IPL/IPLCommonFooter")
);
const MatchInfo = dynamic(() => import("@/component/IPL/MatchInfo"));
const MatchSummary = dynamic(() => import("@/component/IPL/MatchSummary"));
const MatchScoreCard = dynamic(() => import("@/component/IPL/MatchScoreCard"));
const MatchCommentary = dynamic(() =>
  import("@/component/IPL/MatchCommentary")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const SportsEventSchema = dynamic(() =>
  import("@/component/SeoTags/SportsEventSchema")
);

const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const WebsiteSchema = dynamic(() =>
//   import("@/component/SeoTags/WebsiteSchema")
// );
// const IPLFAQSchema = dynamic(() => import("@/component/SeoTags/IPLFAQSchema"));

const MatchDetailPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  matchData = null,
  faqData = null,
  commData = null,
  currentTab = 1,
  recentMatchData = null,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath.substring(
    0,
    router?.asPath.lastIndexOf("/")
  );
  const handleBackClick = () => {
    window.history.back();
  };

  const [latestMatchData, setLatestMatchData] = useState(matchData);
  const [commentary, setCommentary] = useState(commData);
  const isLive = matchData?.status == "LIVE";
  const isUpcoming = matchData?.status == "UPCOMING";
  const isTest = matchData?.type.includes("Test");
  const isAsiaCup = router?.asPath?.includes("/asia-cup-2025/");
  useEffect(() => {
    async function getLiveMatchData() {
      try {
        const timestamp = Date.now();
        const matchResponse = await getDataFromSSR(
          `/api/getLiveMatchDetails?matchId=${matchData?.id}&time=${timestamp}`
        );
        if (matchResponse && matchResponse?.data?.data) {
          const liveMatchData = parseMatchDetails(matchResponse?.data?.data);
          setLatestMatchData(liveMatchData);
        }
        if (currentTab == 3) {
          const commResponse = await getDataFromSSR(
            `/api/getLiveCommentary?matchid=${matchData?.id}&time=${timestamp}`
          );
          if (commResponse) {
            const commData = parseMatchDetails(matchData?.data?.data);
            setCommentary(commData);
          }
        }
      } catch (err) {
        logger.error(err);
      }
    }

    if (matchData.status == "LIVE") {
      getLiveMatchData();
      const interval = setInterval(() => {
        getLiveMatchData();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, []);

  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);
  // useEffect(() => {
  //   async function onFirstScroll() {
  //     if (!scrolled) {
  //       setScrolled(true);
  //     }
  //   }

  //   function handleScroll() {
  //     onFirstScroll();

  //     window.removeEventListener("scroll", handleScroll);
  //   }

  //   window.addEventListener("scroll", handleScroll);
  // }, []);
  // ads

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());

            document.getElementById("div-gpt-ad-1659434785315-0") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434785315-0"
                )
                .addService(googletag.pubads());

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          scrolled &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());

            document.getElementById("div-gpt-ad-1707804176041-1") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                  [300, 250],
                  "div-gpt-ad-1707804176041-1"
                )
                .addService(googletag.pubads());
          }

          if (scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
            document.getElementById("div-gpt-ad-1707804176041-3") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                  [728, 90],
                  "div-gpt-ad-1707804176041-3"
                )
                ?.addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);

  function getSeoTags() {
    switch (currentTab) {
      case 1:
        return {
          title: isTest
            ? "IND vs ENG Test Series 2025 Info: भारत बनाम इंग्लैंड सीरीज की पूरी जानकारी - NewsTak"
            : `Asia Cup 2025 ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Match Info: Venue, Time & Playing XI - Newstak`,
          description: isTest
            ? "India vs England Test Series 2025 की पूरी जानकारी पाएं: मैच शेड्यूल, स्क्वॉड, वेन्यू, लाइव स्ट्रीमिंग डिटेल्स और लेटेस्ट अपडेट्स हिंदी में सिर्फ NewsTak पर"
            : `Asia Cup 2025 Match Info (${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}): Get match details for Asia Cup 2025 ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } - venue, timing, squads, probable playing XI and match info.`,
          keywords: isTest
            ? "India vs England 2025 info, IND vs ENG test series 2025 details, India tour of England 2025 full info, इंग्लैंड बनाम भारत 2025 जानकारी, टेस्ट सीरीज शेड्यूल, लाइव स्ट्रीमिंग इंडिया इंग्लैंड"
            : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Asia Cup 2025, ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } Live, Asia Cup Match Info, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Playing XI, Asia Cup 2025 Match Info ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025 मैच डिटेल्स`,
          canonical: router?.asPath,
        };

      case 2: {
        // Summary
        if (isLive) {
          return {
            title: isTest
              ? "IND vs ENG 2025 Test Live Score: भारत बनाम इंग्लैंड टेस्ट सीरीज़ स्कोर और हर पल की अपडेट - NewsTak"
              : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Live Score, Asia Cup 2025 - ${latestMatchData?.teamA_fullname
              } vs ${latestMatchData?.teamB_fullname} Match (${latestMatchData?.default_date &&
              new Date(latestMatchData?.default_date)
                ?.toLocaleDateString("en-GB")
                ?.replace(/\//g, ",")
              }
) | NewsTak`,
            description: isTest
              ? "India Tour of England 2025 Test Match Live Score: भारत बनाम इंग्लैंड टेस्ट सीरीज़ की हर गेंद की लाइव अपडेट, स्कोर, हीरो प्लेयर और टर्निंग पॉइंट्स की जानकारी सिर्फ NewsTak पर।"
              : `Asia Cup 2025 ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Live Cricket Score: मैच ${latestMatchData?.match_no?.replace(
                /\D/g,
                ""
              )} की हर गेंद का अपडेट, लाइव स्कोर, कमेंट्री और लेटेस्ट स्टैट्स http://Newstak.in  पर पाएँ।`,
            keywords: isTest
              ? "IND vs ENG live score 2025, India vs England 2025 test series live, live cricket updates, इंग्लैंड बनाम भारत लाइव स्कोर, IND vs ENG match updates, India tour of England 2025 scorecard, cricket live commentary Hindi"
              : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} live score, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} live cricket score, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} live today match, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} live, ${latestMatchData?.teamA_fullname
              } vs ${latestMatchData?.teamB_fullname
              } live match, Asia Cup 2025 today live score, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} today match, live cricket score Asia Cup, live score, live scorecard, लाइव क्रिकेट स्कोर`,
            canonical: router?.asPath,
          };
        }
        return {
          title: isTest
            ? "IND vs ENG 2025 Test Series Summary: भारत बनाम इंग्लैंड टेस्ट सीरीज़ का पूरा सारांश - NewsTak"
            : `Asia Cup 2025 ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Match Summary: Highlights & Key Moments - Newstak`,
          description: isTest
            ? "India Tour of England 2025 Summary: जानें सीरीज़ के स्कोर, सबसे बड़े हीरो, टर्निंग मोमेंट्स और हर टेस्ट मैच की झलक। भारत बनाम इंग्लैंड टेस्ट सीरीज़ का फुल रिव्यू सिर्फ NewsTak पर"
            : `Asia Cup 2025 Match Summary (${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}): Read the full summary of Asia Cup 2025 ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } match – key highlights, turning points, player performances and final results.`,
          keywords: isTest
            ? "India vs England 2025 full summary, IND vs ENG test series highlights, India tour of England review, इंग्लैंड बनाम भारत 2025 टेस्ट सीरीज़ सारांश, IND vs ENG key moments, India vs England 2025 score review, cricket summary today"
            : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Summary, ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } Highlights, Asia Cup Match Report, ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} 2025, Asia Cup 2025 Match Summary ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025 मैच समरी`,
          canonical: router?.asPath,
        };
      }

      case 3:
        // Commentary
        return {
          title: isTest
            ? "IND vs ENG Test Series Live Commentary 2025: भारत बनाम इंग्लैंड टेस्ट लाइव कमेंट्री, बॉल-बाय-बॉल अपडेट्स - NewsTak"
            : `Asia Cup 2025 ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Live Commentary: Ball by Ball Updates - Newstak`,
          description: isTest
            ? "Catch ball-by-ball live commentary of India vs England Test Series 2025 (भारत बनाम इंग्लैंड टेस्ट मैच लाइव). Stay updated with real-time score updates, expert insights, and Hindi commentary coverage only on NewsTak."
            : `Asia Cup 2025 Match Commentary (${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}): Follow live commentary of Asia Cup 2025 ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } match with ball-by-ball updates, expert analysis and live match coverage.`,
          keywords: isTest
            ? "IND vs ENG live commentary, India vs England 2025 ball by ball, IND vs ENG live updates, IND vs ENG Test commentary Hindi, cricket live Hindi, इंग्लैंड बनाम भारत लाइव कमेंट्री, क्रिकेट हिंदी कमेंट्री, IND vs ENG ball by ball updates, India tour of England live coverage"
            : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Live Commentary, ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } Live Updates, Asia Cup Ball by Ball, Asia Cup Commentary, Asia Cup 2025 Match Scorecard ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025: बॉल-बाय-बॉल कमेंट्री`,
          canonical: router?.asPath,
        };

      case 4:
        // Scorecard
        return {
          title: isTest
            ? "IND vs ENG 2025 Test Series Scorecard: भारत बनाम इंग्लैंड टेस्ट स्कोर, Full Match Stats & Highlights - NewsTak"
            : `Asia Cup 2025 ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Scorecard: Live Scores & Full Match Stats - Newstak`,
          description: isTest
            ? "Check the full India vs England Test Series 2025 scorecard (भारत बनाम इंग्लैंड टेस्ट स्कोरकार्ड). Get live scores, batting & bowling stats, partnerships, fall of wickets, and match summaries in Hindi only on NewsTak."
            : `Asia Cup 2025 Match Scorecard (${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}): Check the full scorecard of Asia Cup 2025 ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } - live scores, batting, bowling, fall of wickets and match stats.`,
          keywords: isTest
            ? "India vs England 2025 scorecard, IND vs ENG 2025 live score, ENG vs IND Test match stats, live cricket score India vs England, IND vs ENG match summary, IND vs ENG player stats, इंग्लैंड बनाम भारत लाइव स्कोरकार्ड, क्रिकेट स्कोर इंडिया इंग्लैंड"
            : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()} Scorecard, ${latestMatchData?.teamA_fullname
            } vs ${latestMatchData?.teamB_fullname
            } Live Score, Asia Cup 2025 Scorecard, ${latestMatchData?.teamA_name.toUpperCase()}  ${latestMatchData?.teamB_name.toUpperCase()} Match Stats, Asia Cup 2025 Match Scorecard ${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025 स्कोरकार्ड`,
          canonical: router?.asPath,
        };

      default:
        return {
          title: "",
          description: "",
          keywords: "",
          canonical: "",
        };
    }
    // Info
  }
  const { title, description, keywords, canonical } = getSeoTags();
  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title:
        matchData.series_id == "8307"
          ? "IPL"
          : matchData.series_id == "13274"
            ? "Asia Cup 2025"
            : "Cricket",
      canonical_url:
        matchData.series_id == "8307"
          ? "/sports/ipl"
          : matchData.series_id == "13274"
            ? "/sports/asia-cup-2025"
            : "/sports/cricket",
      amp_url: "",
    },
    {
      id: "3",
      title: matchData?.match_title || "",
      canonical_url: router?.asPath,
      amp_url: "",
    },
  ];
  let h1Text = "";
  if (currentTab == 1) {
    h1Text = isTest
      ? "IND vs ENG Test Series 2025 Info"
      : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025 मैच डिटेल्स`;
  }
  if (currentTab == 2) {
    h1Text = isTest
      ? `IND vs ENG 2025 Series ${isLive ? "Live" : "Summary"}`
      : isLive
        ? latestMatchData.teamA_name.toUpperCase() +
        " vs " +
        latestMatchData?.teamB_name.toUpperCase() +
        ", " +
        latestMatchData?.match_date_head +
        " Live Match"
        : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()},  एशिया कप 2025 मैच समरी`;
  }
  if (currentTab == 3) {
    h1Text = isTest
      ? "IND vs ENG Live Commentary 2025"
      : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025: बॉल-बाय-बॉल कमेंट्री`;
  }
  if (currentTab == 4) {
    h1Text = isTest
      ? "IND vs ENG 2025 Test Series Scorecard"
      : `${latestMatchData?.teamA_name.toUpperCase()} vs ${latestMatchData?.teamB_name.toUpperCase()}, एशिया कप 2025 स्कोरकार्ड`;
  }
  const content = `एशिया कप 2025 के हर मैच में किसने जीता टॉस, किसने मारा सबसे ज्यादा रन तो किसने झटके सबसे ज्यादा विकेट, पाइए हर मैच से जुड़ी हर एक छोटी-बड़ी अपडेट इस पेज पर. इस बार कुल 8 टीमें खिताब की दौड़ में शामिल हैं. मौजूदा टी20 चैंपियन श्रीलंका खिताब बचाने उतरेगा, वहीं भारत, जिसने 2023 में वनडे एशिया कप जीता था, मजबूत दावेदार माना जा रहा है. क्रिकेट फैन्स खासतौर पर भारत-पाकिस्तान का हाई-वोल्टेज मुकाबला 14 सितंबर को देखने के लिए उत्साहित हैं. टूर्नामेंट का फाइनल 28 सितंबर को दुबई इंटरनेशनल क्रिकेट स्टेडियम में खेला जाएगा.`;
  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <WebsiteSchema /> */}
      <AsiaCupFAQSchema />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <SportsEventSchema
        title={title}
        description={description}
        startDate={matchData?.default_date}
        venue={matchData?.venue}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <section className="px-4 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
        <div
          onClick={handleBackClick}
          className="cursor-pointer flex items-center justify-start gap-1 -mx-4 md:-mx-0"
        >
          <SVG className="w-4 h-4" src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/leftArrow.svg"></SVG>
          <h1 className="my-4 font-semibold text-md md:text-lg">{h1Text}</h1>
        </div>
        {/* match banner + nav  */}
        <div
          className="bg-cover bg-center w-[108%] -mx-4 md:w-full md:-mx-0 h-fit md:rounded-t-lg py-2 px-2 md:px-4"
          style={{ backgroundImage: 'url("https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prodMatchBanner.png")' }}
        >
          <div className="flex items-center justify-between pb-4 mb-2 my-2 border-b border-[#FFFFFF1A]">
            <span className="text-[#FFFFFFCC] w-[80%] text-sm line-clamp-1 me-4">
              {latestMatchData?.match_title}
            </span>
            <div className="w-[20%] text-[#FFFFFFCC] text-sm text-end mr-2 md:mr-1">
              {isLive ? (
                <span className="flex items-center justify-end gap-1">
                  LIVE
                  <img
                    height={24}
                    width={24}
                    src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveGif.gif"
                    alt="live icon"
                  />
                </span>
              ) : isUpcoming ? (
                "UPCOMING"
              ) : (
                "ENDED"
              )}
            </div>
          </div>

          <div className="w-[80%] md:w-[70%] mx-auto flex items-center gap-1">
            <div className="w-full flex items-center justify-between gap-2 mt-2 md:mt-4 mb-4">
              <div className="w-[46%] flex flex-col -ml-4 md:-ml-0 md:flex-row items-center gap-1 justify-start">
                <img
                  width={50}
                  height={50}
                  src={
                    latestMatchData.altLogoA ||
                    latestMatchData.teama_logo ||
                    ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${latestMatchData?.teamA_name}1.png`
                  }
                  alt="teamA logo"
                  className="w-[60px] md:w-[50px]   mr-1"
                />
                <div className="flex flex-col items-center md:items-start justify-center text-white">
                  <span className="flex items-center gap-0 font-semibold text-md ">
                    {latestMatchData?.teamA_name.toUpperCase()}
                    {latestMatchData?.winning_team == "A" && (
                      <img
                        src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="-mt-1"
                      />
                    )}
                  </span>
                  <span className="font-extralight opacity-70 text-sm">
                    {isTest
                      ? matchData?.teamA_score_full?.replace(/\,/g, " | ") || ""
                      : latestMatchData?.teamA_score
                        ? latestMatchData?.teamA_score
                        : ""}{" "}
                    {!isTest && latestMatchData?.teamA_overs
                      ? latestMatchData?.teamA_overs || ""
                      : ""}
                    {latestMatchData?.batting_team == "A" && <span>{"*"}</span>}
                  </span>
                </div>
              </div>

              <div
                className={`font-light w-[55%] md:w-[40%] text-white text-sm flex flex-col items-center justify-center`}
              >
                <span className="text-[#FFFFFFCC]">
                  {latestMatchData?.match_no}
                </span>
                <span className="text-center">
                  {isUpcoming
                    ? latestMatchData?.match_date.split(",")[1].trim()
                    : latestMatchData?.status == "ENDED"
                      ? "Match Ended"
                      : latestMatchData?.live_status}
                </span>
                <span className="md:hidden text-center text-[#FFFFFFCC] mt-2">
                  {matchData?.equation}
                </span>
              </div>

              <div className="w-[46%] flex flex-col md:flex-row -mr-4 md:-mr-0 items-center gap-1 justify-end">
                <div className="hidden md:flex flex-col items-end justify-center text-white">
                  <span className="flex items-center gap-0 font-semibold text-md">
                    {latestMatchData?.winning_team == "B" && (
                      <img
                        src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="-mt-1"
                      />
                    )}
                    {latestMatchData?.teamB_name.toUpperCase()}
                  </span>
                  <span className="hidden md:block font-extralight opacity-70 text-sm text-right">
                    {isTest
                      ? matchData?.teamB_score_full?.replace(/\,/g, " | ")
                      : latestMatchData?.teamB_score
                        ? latestMatchData?.teamB_score
                        : ""}{" "}
                    {!isTest && latestMatchData?.teamB_overs
                      ? latestMatchData?.teamB_overs || 0
                      : ""}
                    {latestMatchData?.batting_team == "B" ? (
                      <span>{"*"}</span>
                    ) : (
                      <></>
                    )}
                  </span>
                </div>
                <img
                  width={50}
                  height={50}
                  src={
                    latestMatchData.altLogoB ||
                    ` https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/${latestMatchData?.teamB_name}1.png`
                  }
                  alt="teamB logo"
                  className="w-[60px] md:w-[50px]  ml-1"
                />
                <div className="flex md:hidden flex-col items-center justify-center text-white">
                  <span className="flex items-center gap-1 font-semibold text-md">
                    {latestMatchData?.winning_team == "B" && (
                      <img
                        src={"https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/trophy.gif"}
                        width={20}
                        height={20}
                        alt="trophy gif"
                        className="-mt-1"
                      />
                    )}
                    {latestMatchData?.teamB_name.toUpperCase()}
                  </span>
                  <span className="md:hidden font-extralight opacity-70 text-sm text-center">
                    {isTest
                      ? matchData?.teamB_score_full?.replace(/\,/g, " | ")
                      : latestMatchData.teamB_score
                        ? latestMatchData.teamB_score
                        : ""}{" "}
                    {!isTest && latestMatchData.teamB_overs
                      ? (latestMatchData.teamB_overs || 0)
                      : ""}{" "}
                    {latestMatchData?.batting_team == "B" && <span>{"*"}</span>}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden md:block text-[#FFFFFFCC] w-full text-center">
            {latestMatchData?.equation}
          </div>
          <div className="relative flex items-center justify-start -ml-3 md:-ml-0 gap-2 md:gap-4 text-md text-white pl-4 mt-2 -mb-2">
            <a
              className={`p-2 ${currentTab == 1 ? "border-b-4 border-primary" : ""
                }`}
              href={currentPath + "/info"}
            >
              Info
            </a>
            <a
              className={`p-2 ${currentTab == 2 ? "border-b-4 border-primary" : ""
                }`}
              href={
                currentPath +
                (latestMatchData?.status == "LIVE" ? "/live" : "/summary")
              }
            >
              {latestMatchData?.status === "ENDED" || isUpcoming
                ? "Summary"
                : "Live"}
            </a>
            <a
              className={`p-2 ${currentTab == 3 ? "border-b-4 border-primary" : ""
                }`}
              href={currentPath + "/commentary"}
              rel="nofollow noopener noreferrer"
            >
              Commentary
            </a>
            <a
              className={`p-2 ${currentTab == 4 ? "border-b-4 border-primary" : ""
                }`}
              href={currentPath + "/scorecard"}
            >
              Scorecard
            </a>
          </div>
        </div>
        {scrolled && (
          <div className="my-3">
            <AdSlot300x250
              divId={"div-gpt-ad-1659434604998-0"}
              minWidth="300px"
              minHeight="250px"
            />

            <AdSlot728x90
              divId={"div-gpt-ad-1707804176041-2"}
              minWidth="720px"
              minHeight="90px"
            />
          </div>
        )}
        <div className="py-4 w-full">
          {currentTab == 1 && (
            <MatchInfo
              matchData={latestMatchData}
              recentMatchData={recentMatchData}
              scrolled={scrolled}
            />
          )}
          {currentTab == 2 && (
            <MatchSummary
              matchData={isUpcoming ? null : latestMatchData}
              scrolled={scrolled}
              isTest={isTest}
            />
          )}
          {currentTab == 3 && (
            <MatchCommentary
              matchData={isUpcoming ? null : latestMatchData}
              commData={commentary}
              scrolled={scrolled}
              isTest={isTest}
            />
          )}
          {currentTab == 4 && (
            <MatchScoreCard
              matchData={isUpcoming ? null : latestMatchData}
              scrolled={scrolled}
              isTest={isTest}
            />
          )}
        </div>
        <IPLCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
          customHeading={isTest ? "रिलेटेड न्यूज" : null}
          showContent={true}
          isAsiaCup={isAsiaCup}
          content={content}
        />
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default MatchDetailPage;
